import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { weightt34o7llf2uyq as weight } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.commonHtml.mjs';
import { Companion_getInstance2xbytizsyx2ps as Companion_getInstance } from '../../../../../kiteui-library/com/lightningkite/kiteui/ViewWrapper.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var ColumnWeightsClass;
function ColumnWeights() {
  if (ColumnWeightsClass === VOID) {
    class $ {
      constructor() {
        this.kg6_1 = ArrayList().w();
        this.lg6_1 = 0;
        this.mg6_1 = null;
        this.ng6_1 = null;
      }
      og6(_this__u8e3s4, amount) {
        this.kg6_1.v(amount);
        return weight(_this__u8e3s4, amount);
      }
      pg6(_this__u8e3s4) {
        weight(_this__u8e3s4, this.kg6_1.q1(this.lg6_1));
        this.lg6_1 = (this.lg6_1 + 1 | 0) % this.kg6_1.p1() | 0;
        return Companion_getInstance();
      }
    }
    initMetadataForClass($, 'ColumnWeights', ColumnWeights);
    ColumnWeightsClass = $;
  }
  return ColumnWeightsClass;
}
function trackWeights(setup) {
  // Inline function 'kotlin.run' call
  setup(new (ColumnWeights())());
  return Unit_instance;
}
//region block: exports
export {
  trackWeights as trackWeights2d4yjn3jzod5x,
};
//endregion

//# sourceMappingURL=ColumnWeights.mjs.map
